<div class="pension-reserve-preview" *ngIf="model != null">

  <!--
    3 aligned lines:
    | A:Progression de mon épargne     |                            C:totalAmount |
    | t                                | t                  |                   t |
    |XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX|                                          |
    |                                  | t                                        |
    |                                  | B:vestedAmount
  -->
  <div class="progression-view" *ngIf="showBar">
    <ng-template #progressionTitleTemplate>
      <label class="title">Progression de mon épargne</label>
    </ng-template>
    <ng-template #progressionVestedLabel>
      {{ model.totalVestedReserveAmount | cCurrency }}
    </ng-template>
    <ng-template #totalAmountLabel>
      {{ model.totalEstimatedPensionAmount | cCurrency }}
    </ng-template>

    <div class="up-labels">
      <div class="col1">
        <ng-container *ngTemplateOutlet="progressionTitleTemplate"></ng-container>
      </div>
      <div class="collast">
        <ng-container *ngTemplateOutlet="totalAmountLabel"></ng-container>
      </div>
    </div>
    <div class="up-tickers">
      <div class="collast">
        <i class="ticker ticker-right fa fa-fw fa-caret-down"></i>
      </div>
    </div>
    <div class="chart">
      <div class="col1" [style.width]="model.vestedReserveWidthCss">
        <span class="label">
            {{ model.vestedReserveRatio | percent }}
        </span>
      </div>
      <div class="collast"></div>
    </div>
    <div class="down-tickers">
      <div class="col1" [style.width]="model.vestedReserveWidthCss">
        <i class="ticker ticker-right fa fa-fw fa-caret-up"></i>
      </div>
    </div>
    <div class="down-labels">
      <div class="col1" [style.width]="model.vestedReserveWidthCss">
      </div>
      <div class="col2">
        <ng-container *ngTemplateOutlet="progressionVestedLabel"></ng-container>
      </div>
      <div class="collast">
      </div>
    </div>

  </div>

  <div class="progression-details" *ngIf="showText">
    <p>
      {{ model.totalVestedReserveAmount | cCurrency }} épargnés (montant total des réserves) et une estimation
      de {{ model.totalEstimatedPensionAmount | cCurrency }} à la pension.
    </p>
    <ul style="font-size: .8em">
      <li>
        Le rapport partagé permet de constater les ordres de grandeurs, seuls les décomptes des compagnies ont valeurs légales.
      </li>
      <li>
        La projection de pension est brute.
      </li>
      <li>
        Les montants sont mis à jour trimestriellement pour les contrats des compagnies (plus de précision contrat par contrat).
      </li>

    </ul>
  </div>

</div>
